import { useEffect, useState } from "react";
import { TABLE_COLUMN_PREFERENCES_CHANGED } from "../utils/tableColumnPreferences";

/** Bump when column order preferences change so dependent memos re-run. */
export function useTableColumnPreferencesVersion(tableId) {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const onChange = (event) => {
      const changedId = event?.detail?.tableId;
      if (!changedId || changedId === tableId) {
        setVersion((v) => v + 1);
      }
    };
    window.addEventListener(TABLE_COLUMN_PREFERENCES_CHANGED, onChange);
    return () => window.removeEventListener(TABLE_COLUMN_PREFERENCES_CHANGED, onChange);
  }, [tableId]);

  return version;
}
